import type { UploadKindAdapter } from '@/lib/uploads/upload-kind-adapter';
import { transitionDocumentUploadAdapter } from '@/pages/property-transitions/_lib/transition-documents-upload-adapter';

/**
 * Central registry of upload kind adapters.
 * Add new feature adapters here when introducing additional upload kinds.
 */
export const uploadKinds = [
  transitionDocumentUploadAdapter,
] satisfies UploadKindAdapter[];
